var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#3EC1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_723_37567",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#7AD2FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#88E318"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.417 23.27c-.25-.718-.702-.793-.897-.741-1.494 0-3.43 1.17-5.691-1.91-1.338-1.823.35-4.328.896-5.108.546-.78 1.287-1.481 1.91-2.183.624-.702 1.404-.39 1.833-.507.429-.117 1.95.078 2.573.507.624.429.663 1.208 1.442 1.754.78.546.897 0 1.443-.546.546-.545 1.404.156 2.456.546 1.053.39 2.222 3.899 2.573 5.107.351 1.209 2.067.858 2.807 1.326.741.468-1.793 2.69-2.573 3.548-.78.857.117 2.066 0 2.846-.117.78-.624.428-1.091 1.13-.468.702-.234 1.326-.468 1.443-.187.093-.624.74-.819 1.052-.689 1.04-2.34 2.963-3.43 2.34-1.365-.78-2.34-5.576-1.99-7.057.352-1.481.274-1.092-.35-1.754-.624-.663-.312-.897-.624-1.794zM1.942 18.636c-.56.03-1.195-1.131-1.442-1.716.717-7.298 4.77-10.89 6.706-11.774 3.82 2.495.623 5.263.312 5.926-.312.663-2.067 3.275-2.184 3.626-.117.35-1.598 1.053-1.949 1.364-.35.312 1.053 1.482 1.17 1.989.117.507-1.91.546-2.612.585zM2.995 21.014l-2.34.818c0 6.706 4.68 11.605 7.018 13.217.312-1.105.944-3.486.975-4.172.039-.857 1.325-1.014 2.183-1.793.858-.78-.935-1.365-.624-3.314.25-1.56-2.053-2.08-3.235-2.144l-3.977-2.612zM29.506 32.32c-1.123.561-1.404-.598-1.404-1.248 0-.26.078-.858.39-1.17.39-.39 0-1.403 0-1.988s1.287-1.013 1.755-1.052c.467-.04.155-1.248.896-1.365.741-.117-.234 6.12-1.637 6.823z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.073 3.08c.967-.405 1.936-2.118 2.3-2.924 13.84 0 18.168 14.425 18.09 15.439-.062.81-1.611 1.949-2.378 2.417-.351-2.417-3.587-4.445-4.133-4.406-.545.04-.156.975 0 1.677.156.702-2.69 1.754-4.171 2.144-1.482.39-1.014-2.651-2.223-5.302-1.208-2.651-8.42-2.495-9.473-2.495-1.053 0-2.105 1.091-2.73 1.637-.623.546-1.676-1.56-2.183-2.261-.506-.702.741-3.041 1.248-3.86.507-.818 4.444-1.56 5.653-2.066z"
  }))));
}
SvgEarth.displayName = 'Earth';
export default SvgEarth;